import { useEffect, useState } from 'react';
import { Button, Input } from 'antd';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { SiGooglegemini } from 'react-icons/si';
import AccessOrNot from '../../funcs/accessOrNot';
import showFlowEditorUpgrade from '../../funcs/flowEditorUpgrade';

export const AI_PROMPT_EXAMPLES = [
    'Create an automation that collects email from whoever replies "join" to my stories, tags them and sends it to my Kit integration',
    'Make Claude reply to all my incoming DMs — qualify leads and collect their email',
    'When someone comments "price" on my reel, DM them the price list and collect their WhatsApp number',
    'Collect name and email, wait 20 seconds, then send a thank-you message using their name',
    'When someone replies to my story, send a discount code and tag them story-lead',
    'DM my course link to anyone who comments "learn", and if they don\'t reply in 30 minutes send a reminder',
];

/**
 * "Describe it → AI builds it" prompt box. Enter hands the prompt to a fresh
 * flow editor whose AI builder auto-runs it. Reused on the home page and in
 * the New Automation (template) popup.
 */
export default function AiFlowPromptBox({ style, platform = "instagram" }) {
    const navigate = useNavigate();
    const [text, setText] = useState('');
    const [placeholderIndex, setPlaceholderIndex] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => setPlaceholderIndex((i) => (i + 1) % AI_PROMPT_EXAMPLES.length), 4500);
        return () => clearInterval(timer);
    }, []);

    const start = () => {
        const value = text.trim();
        if (!value) return;
        // The AI builder lives inside the Flow Editor — same plan gate.
        if (!AccessOrNot('flow_editor')) {
            showFlowEditorUpgrade();
            return;
        }
        navigate(`/flow-v2/editor?id=${uuidv4()}&ai_prompt=${encodeURIComponent(value)}&platform=${platform}`);
    };

    return (
        <div
            style={{
                display: 'flex', alignItems: 'center', gap: 10,
                border: '1px solid transparent',
                borderRadius: 14, padding: '10px 12px',
                backgroundImage: 'linear-gradient(var(--idm-surface, #fff), var(--idm-surface, #fff)), linear-gradient(45deg, #f09433, #dc2743, #bc1888, #4f5bd5)',
                backgroundOrigin: 'border-box',
                backgroundClip: 'padding-box, border-box',
                boxShadow: '0 2px 10px rgba(79, 91, 213, 0.08)',
                ...style,
            }}
        >
            <span style={{ width: 34, height: 34, borderRadius: 10, flexShrink: 0, background: '#eef2ff', color: '#6366f1', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 17 }}>
                <SiGooglegemini />
            </span>
            <Input.TextArea
                autoSize={{ minRows: 1, maxRows: 3 }}
                bordered={false}
                value={text}
                onChange={(e) => setText(e.target.value)}
                onPressEnter={(e) => { if (!e.shiftKey) { e.preventDefault(); start(); } }}
                placeholder={AI_PROMPT_EXAMPLES[placeholderIndex]}
                style={{ fontSize: 14, padding: 0 }}
            />
            <Button type="primary" onClick={start} disabled={!text.trim()} style={{ flexShrink: 0, fontWeight: 500 }}>
                Build with AI
            </Button>
        </div>
    );
}
